<template>
    <div class=" section_sectionWrapper">
        <div class="module-newsDetail">
            <div class="title"></div>
            <div class="news-cont">
                <!-- 新闻详情 -->
                <div class="detail">
                    <div class="d-cnt">
                        <div class="t-tag" @click="handleBack()">
                            <div class="new-back"></div>
                        </div>
                        <div class="d-title">
                            <div class="item-tag"> {{ detail.tag }}</div>
                            <div class="item-title">
                                <div class="line-clamp-1"> {{ detail.title }}</div>
                                <div class="item-time">{{ common.tsformat(detail.time) }}</div>
                            </div>
                        </div>
                        <div>
                            <div class="d-img">
                                <img :src="detail.indexPicUrl" width="100%" height="100%" />
                            </div>

                            <pre><div class="d-item-cnt" v-html="transBr(detail.context)"></div></pre>
                        </div>
                    </div>
                    <!-- <div class="s-footer"></div> -->
                </div>

            </div>

        </div>

    </div>
</template>
<script>
export default {
    name: 'app',
    data() {
        return {
            detail: null

        }
    },
    watch: {

    },
    created() {
        this.handleDetail(this.$route.query.id);
    },
    methods: {
        transBr(val) {
            return (val + "").replace(/\n/g, "<br/>");
        },
        handleBack() {
            this.$router.push({
                path: "/",
                query: { view: 6 },
            })
        },
        handleDetail(id) {
            const reqTime = Math.floor(new Date().getTime() / 1000);
            const params = {
                id
            };
            params.signature = this.common.makeSignature(params, reqTime);
            params.reqTime = reqTime;
            this.$axios({
                method: "post",
                url: "news/view",
                data: params,
                //withCredentials:true, //局部携带cookie
                headers: {}, //如果需要添加请求头可在这写
            })
                .then((res) => {
                    this.detail = res.data.data
                })
                .catch((err) => {
                    //请求失败就会捕获报错信息
                    //err.response可拿到服务器返回的报错数据
                });
        },
    }
}
</script>
<style lang="scss" scoped>
.module-newsDetail {
    position: relative;
    height: 100%;
    width: 100%;

    scroll-behavior: smooth;
    background-size: 100% 100%;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    background-size: cover !important;
    background: url('../assets/img/bg.jpg') no-repeat;

    .s-footer {
        bottom: 0;
        position: absolute;
    }

    .title {
        width: 320px;
        height: 105px;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 60px;
        transform: translateX(-50%);
        background-image: url("../assets/img/news/title.png");
    }

    .detail {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .news-cont {

        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 150px;

        .d-cnt {

            width: 940px;
        }

        .t-tag {

            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .new-back {
                background: url("../assets/img/news/back.png") no-repeat;
                background-size: 100% 100%;
                width: 119px;
                height: 39px;
            }
        }

        .detail {



            .t-tag {
                justify-content: end;
                margin: 0;
            }

            .d-title {

                height: 53px;
                font-size: 18px;
                font-weight: bold;
                opacity: 0.93;
                display: flex;
                align-items: center;
                margin-bottom: 32px;

                .item-tag {
                    background-color: #9ac9dd;
                    color: #fff;
                    padding: 6px 0;
                    width: 152px;
                    text-align: center;
                }

                .item-title {
                    width: 788px;
                    background-color: #fff;
                    color: #586776;
                    opacity: 0.93;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 6px 20px;

                }

                .item-time {
                    color: #8899a5;
                    font-weight: normal;
                    font-size: 14px;
                }
            }

            .d-item-cnt {
                // text-align: center;
                // width: 100%;
                // overflow-y: scroll;



            }



        }

    }


}

@media screen and (max-width: 1200px) {
    .module-newsDetail {
        .news-cont {}
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .module-newsDetail {
        .title {
            width: 288px !important;
            height: 94px !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/NewsEvent.vue